import { QUIZ_URL } from "../../constants";
import { apiSlice } from "../apiSlice";

const quizGroupSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizGroups: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/group`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['QuizGroups']
    }),
    getQuizGroupDetails: builder.query({
      query: (quizGroupId) => ({
        url: `${QUIZ_URL}/group/${quizGroupId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['QuizGroup'],
    }),
    getQuizGroupOpenChallenges: builder.query({
      query: (quizGroupId) => ({
        url: `${QUIZ_URL}/group/challenges/${quizGroupId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['QuizGroup'],
    }),
    addQuizGroup: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/group`,
        method: 'Post',
        body: data,
      }),
      invalidatesTags: ['QuizGroup'],
    }),
    createChallenge: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/challenge`,
        method: 'Put',
        body: data,
      }),
      invalidatesTags: ['QuizGroup'],
    }),
    updateQuizGroup: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/group`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['QuizGroups'],
    }),
    deleteQuizGroup: builder.mutation({
      query: (quizGroupId) => ({
        url: `${QUIZ_URL}/group/${quizGroupId}`,
        method: 'DELETE',
      })
    }),
  }),
});

export const {
    useGetQuizGroupsQuery,
    useGetQuizGroupDetailsQuery,
    useLazyGetQuizGroupOpenChallengesQuery,
    useAddQuizGroupMutation,
    useUpdateQuizGroupMutation,
    useCreateChallengeMutation,
    useDeleteQuizGroupMutation,
 } = quizGroupSlice;